// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"errorMainPage_errorWrapper__iags0","backBtn":"errorMainPage_backBtn__db5yo"};